import React, { Component } from "react";


export default class Error500 extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    //console.log("################### getDerivedStateFromError ####################")
    //console.log(error)
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // You can also log the error to an error reporting service
    //logErrorToMyService(error, info);
    /*console.log("################### componentDidCatch ####################")
    console.log(error)
    console.log(info)*/
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-500">
          <div id="notfound">
            <div className="notfound">
              <div className="notfound-404">
                <h1>500</h1>
              </div>
              <h2>Error Inesperado</h2>
              <p>Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste.</p>
              <div className="imagen">
                <img src="/Logo_CU_Verde.PNG" />
              </div>
              {/*<div className="notfound-social">
                <a href="https://www.facebook.com/CooperativaUniversitaria?fref=ts"><i className="fa fa-facebook"></i></a>
                <a href="https://twitter.com/CU_Py"><i className="fa fa-twitter"></i></a>
                <a href="https://www.youtube.com/user/coopuniversitaria"><i className="fa fa-youtube"></i></a>
                <a href="https://api.whatsapp.com/send?phone=595985251700"><i className="fa fa-whatsapp"></i></a>
              </div>*/}
            </div>
          </div>
        </div>
      );
    }


    return this.props.children;
  }
}